import { FeaturesListDto } from '@givz/core-client';
import { useCoreClientFetch } from '@hooks/core-client';
import { featuresState } from '@states';
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';

export const useFetchGivzFeatures = () => {
  const [, setFeatures] = useRecoilState(featuresState);
  const { data } = useCoreClientFetch<FeaturesListDto>({
    coreClientFetch: (coreClient) => coreClient.Features.getAll(),
  });
  useEffect(() => {
    setFeatures(data?.features ?? []);
  }, [data?.features, setFeatures]);
};
